import React, { Component } from "react";
import "./Splash.css";
import { Redirect } from "react-router-dom";
import LoaderLogo from "../../components/Loader/LoaderLogo.js";

function AnimatedSplash(props) {
  return (
    <div className="logo_wrapper">
      <div
        className="screen"
        onAnimationEnd={(event) => {
          if (
            event.target === event.currentTarget &&
            event.animationName === "sj-splash-exit"
          ) {
            props.onComplete();
          }
        }}
        style={{
          background: `radial-gradient(circle at 50% 38%, ${props.theme.headerColor}, transparent 28rem), ${props.theme.body}`,
        }}
      >
        <LoaderLogo id="logo" theme={props.theme} />
      </div>
    </div>
  );
}

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  componentDidMount() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
      .matches;
    this.id = setTimeout(
      () => this.setState({ redirect: true }),
      reduceMotion ? 1000 : 5200
    );
  }

  componentWillUnmount() {
    clearTimeout(this.id);
  }

  render() {
    return this.state.redirect ? (
      <Redirect to="/home" />
    ) : (
      <AnimatedSplash
        theme={this.props.theme}
        onComplete={() => this.setState({ redirect: true })}
      />
    );
  }
}

export default Splash;
